var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{attrs:{"flat":"","height":"40","color":_vm.color}},[_c('v-toolbar-title',{class:_vm.color ? 'white--text' : ''},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }